<template>
  <v-snackbar
    v-model="snackbar"
    color="primary"
    :timeout="timeout">
    <v-row class="notification">
      <v-col cols="2" class="py-0">
        <v-btn icon @click="callback()" class="icon">
          <v-avatar>
            <v-img
              @click="callback()"
              src="//www.stthomas.edu/apple-icon-180x180.png" />
          </v-avatar>
        </v-btn>
      </v-col>
      <v-col cols="10" class="py-0">
        <h2 class="header">{{ title }}</h2>
        <a
          class="content"
          @click="callback()">
          {{ text }}
        </a>
      </v-col>
    </v-row>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="snackbar = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'PWA',
  props: {
  },
  data () {
    return {
      snackbar: false,
      propted: false,
      refreshing: false,
      updateExists: false,
      deferredPrompt: null,
      registration: '',

      // Snackbar contents
      title: '',
      text: '',
      callback: null,
      timeout: -1
    }
  },
  created () {
    if (localStorage.prompt) {
      this.prompted = localStorage.prompted
    }

    if (!this.prompted) {
      window.addEventListener('beforeinstallprompt', (e) => {
        this.triggerInstallPrompt(e)
      })
    }

    document.addEventListener('swUpdated', (e) => {
      this.triggerUpdatePrompt(e)
    }, { once: true })

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },
  methods: {
    openSnackbar (params) {
      this.title = params.title
      this.text = params.text
      this.callback = params.callback
      this.timeout = params.timeout

      this.snackbar = true
    },
    triggerInstallPrompt (e) {
      e.preventDefault()
      this.deferredPrompt = e

      this.openSnackbar({
        title: 'Add to Home Screen',
        text: 'Add the UST Campus Map to your home screen for easy access',
        callback: this.installPromptConfirm,
        timeout: 5000
      })

      this.prompted = true
      localStorage.prompted = true
    },
    triggerUpdatePrompt (e) {
      this.registration = e.detail
      this.updateExists = true

      this.openSnackbar({
        title: 'New version available!',
        text: 'Click here to refresh your application to the newest version',
        callback: this.updatePromptConfirm,
        timeout: -1
      })
    },
    installPromptConfirm () {
      this.snackbar = false

      if (this.deferredPrompt !== null) {
        this.deferredPrompt.prompt()

        this.deferredPrompt.userChoice
          .then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt')
            } else {
              console.log('User dismissed the A2HS prompt')
            }

            this.deferredPrompt = null
          })
      }
    },
    updatePromptConfirm () {
      this.updateExists = false

      this.snackbar = false

      if (!this.registration || !this.registration.waiting) { return }
      this.registration.waiting.postMessage('skipWaiting')
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  max-height: 100px;

  .content {
    margin-bottom: 0;
    color: white;
  }

  .icon {
    width: 100%;
    height: 100%;
  }
}
</style>
